import React from 'react';
import Box from '@mui/material/Box';
import { Button, styled } from '@mui/material';
import { useHistory } from 'react-router-dom';

const Page = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const Error = styled(Box)(({ theme }) => ({
  errorNumber: {
    color: theme.palette.text.primary,
    fontWeight: 400,
    lineHeight: 1,
    marginBottom: 30,
    textShadow: '10px 6px 8px hsla(0,0%,45.9%,.8)',
  },
}));

const Error404: React.FC = () => {
  const history = useHistory();

  return (
    <Page>
      <Error fontSize={{ xs: 80, sm: 80 }}>404</Error>
      <Box fontSize={{ xs: 16, sm: 24 }} mb={8} color="grey.500">
        Page not found
      </Box>
      <Button variant="outlined" onClick={() => history.push('/')}>
        Go to homepage
      </Button>
    </Page>
  );
};

export default Error404;
